import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { FaYoutube, FaFacebookF, FaLinkedinIn, FaInstagram, FaTiktok } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {PRIVACY_POLICY,COOKIE_POLICY } from "../../../constants/urls";


const Footer = ({ siteConfig }) => {


  const { t } = useTranslation();

  return (
    <footer className="bg-blue-600 text-white py-10" style={{ backgroundColor: '#3C86A7' }}>
      <div className="container mx-auto px-6 lg:px-16">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start">
          {/* Left - Contact Text */}
          <div className="lg:w-1/2 text-center lg:text-left">
            <h4 className="uppercase tracking-widest font-semibold text-sm footer-title-font ">{t("sections.footer_contacts")}</h4>
            <h2 className="text-3xl  mt-2 footer-breif-font">{t("sections.footer_contact_title")}</h2>
            <p className="text-gl-200 mt-4 leading-relaxed footer-desc-font">
              {t("sections.footer_contact_description")}
            </p>
          </div>

          {/* Right - Contact Info */}
          <div className="lg:w-1/2 flex flex-col lg:flex-row justify-around mt-10 lg:mt-0 text-center lg:text-left">
            {/* Address */}
            <div className="flex flex-col items-center lg:items-start">
              <div className="p-3 rounded-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
                <FaMapMarkerAlt size={20} />
              </div>
              <h5 className="mt-3  footer-icon-title-font"> {t("sections.footer_address")}</h5>
              <p className="text-gl-200 mt-1 footer-icon-desc-font " >{siteConfig?.general?.address}</p>

            </div>

            {/* Contact */}
            <div className="flex flex-col items-center lg:items-start mt-8 lg:mt-0">
              <div className=" p-3 rounded-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
                <FaPhoneAlt size={20} />
              </div>
              <h5 className="mt-3  footer-icon-title-font">{t("sections.footer_contacts")}</h5>
              <p className="text-gl-200 mt-1 footer-icon-desc-font">{siteConfig?.general?.phone_number ?? '02 3954 0787'}</p>
              <p className="text-gl-200 footer-icon-desc-font"> {siteConfig?.general?.email ?? 'hi@londahelpcenter.it'} </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-10 border-t  pt-6 flex flex-col lg:flex-row justify-between items-center">
          <p className="text-gl-200 text-sm footer-copyright-font">
            {siteConfig?.general?.copyright ?? '© 2026 LONDA All rights reserved. P.IVA e C.F. 11735470962'}

          </p>

          {/* Privacy & Cookie Links */}
          <div className="flex space-x-6 mt-4 lg:mt-0 text-sm">
            <a href={PRIVACY_POLICY}  className="text-gray-200 hover:text-white transition">{t("sections.footer_privacy_policy")}</a>
            <a href={COOKIE_POLICY} className="text-gray-200 hover:text-white transition">{t("sections.footer_cookie_policy")}</a>
          </div>

          {/* Social Icons */}
          <div className="flex space-x-4 mt-6 lg:mt-0">
            <a href={siteConfig?.social_links?.youtube ?? '#'} target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-white transition"><FaYoutube size={20} /></a>
            <a href={siteConfig?.social_links?.facebook ?? '#'} target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-white transition"><FaFacebookF size={20} /></a>
            <a href={siteConfig?.social_links?.linkedin ?? '#'} target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-white transition"><FaLinkedinIn size={20} /></a>
            <a href={siteConfig?.social_links?.instagram ?? '#'} target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-white transition"><FaInstagram size={20} /></a>
            <a href={siteConfig?.social_links?.tiktok ?? '#'} target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-white transition"><FaTiktok size={20} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
